import React from 'react'
import FormDialog from '../../../../library/form/components/FormDialog';
import withView from '../../../cmn/docAutomation/withView';
import FormTitle from '../../../../library/form/components/FormTitle';
import BomCMNItemEditor from './BomCMNItemEditor';
import {CmnStoneSearch} from '../../../cmn/snippet/Index';
import { UiGridColOne,UiCol } from "../../../../library/layout/Index";

const BomStoneEditor = (props) => {
    const { formObject, viewData, masterKeys, ...restProps } = props;

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{ height: '350px' }}
            formStyle={{ width: '635px' }} formTitle={<FormTitle formObject={formObject} masterKeys={masterKeys} value="Stone Editor" />}
        >
            <UiGridColOne>
                <UiCol>
                    <ul>
                        <li>
                            <CmnStoneSearch formObject={formObject} rowKey="" viewData={viewData} masterKeys={masterKeys} {...restProps} />
                        </li>
                        <BomCMNItemEditor {...props} />
                    </ul>
                </UiCol>
            </UiGridColOne>
        </FormDialog>
    )
}

export default withView(BomStoneEditor, "bomItem", "bomItem")